<div>
    <div class="head-section">
        <p class="header-text">First Time Login, Reset password</p>
    </div>

    <div class="body-section">
        <div class="row justify-content-center mb-4">
            <div style="position: relative;border: 1px solid #ddd;border-radius: 10px; margin-top: 10px">
                <form  [formGroup]="verifyForm" (ngSubmit)="submit()">
                    <div class="row p-2">
                        <div class="col-md-12">
                            <div class="tax-due-comp d-flex flex-column mb-4">
                                <div class="d-flex flex-row justify-content-between">
                                    <label>Previous Password</label>
                                </div>
                                <div class="d-flex flex-row">
                                    <input placeholder="Old Password" formControlName="old"type="password" />
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="tax-due-comp d-flex flex-column mb-4">
                                <div class="d-flex flex-row justify-content-between">
                                    <label>New Password</label>
                                </div>
                                <div class="d-flex flex-row">
                                    <input placeholder="Enter Password" formControlName="password" type="password"/>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="tax-due-comp d-flex flex-column mb-4">
                                <div class="d-flex flex-row justify-content-between">
                                    <label>Re-Enter Password</label>
                                </div>
                                <div class="d-flex flex-row">
                                    <input placeholder="Confirm Password" formControlName="confirm" type="password" (keyup)="checkPassword()"/>
                                </div>
                                <small class="text-danger" *ngIf="verifyForm.get('confirm').touched && errorMessage">{{errorMessage}}</small>
                            </div>
                        </div>


                        <div>
                            <button class="btn btn-block btn-warning" type="submit" style="width: 100%">
                                <b *ngIf="!login" >Reset Password</b>
                                <b *ngIf="login"  class="spinner-border text-dark"></b>
                            </button>
                        </div>
                    </div>
                </form>
        </div>
    </div>
</div>